module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generate"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCheckBox),
      expression: "showCheckBox"
    }],
    ref: "checkForm",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.checkForm,
      "rules": _vm.checkRules
    }
  }, [_c('h1', [_vm._v("Generate License")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "number"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "ER number"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onClickCheck.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.checkForm.number),
      callback: function($$v) {
        _vm.$set(_vm.checkForm, "number", $$v)
      },
      expression: "checkForm.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.logining
    },
    on: {
      "click": _vm.onClickCheck
    }
  }, [_vm._v("Check")])], 1)], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenseTypeBox),
      expression: "showLicenseTypeBox"
    }],
    ref: "erNumForm",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.erNumForm,
      "rules": _vm.searchRules
    }
  }, [_c('h1', [_vm._v("Generate License")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "option"
    }
  }, [_c('el-cascader', {
    ref: "eventCascader",
    attrs: {
      "options": _vm.options,
      "show-all-levels": false,
      "placeholder": "Select License Type"
    },
    on: {
      "change": _vm.elCascaderOnlick
    },
    model: {
      value: (_vm.erNumForm.option),
      callback: function($$v) {
        _vm.$set(_vm.erNumForm, "option", $$v)
      },
      expression: "erNumForm.option"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "number"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showFileUpload),
      expression: "!showFileUpload"
    }],
    attrs: {
      "placeholder": "ER number"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onClickGen.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.erNumForm.number),
      callback: function($$v) {
        _vm.$set(_vm.erNumForm, "number", $$v)
      },
      expression: "erNumForm.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showFileUpload),
      expression: "!showFileUpload"
    }],
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.logining
    },
    on: {
      "click": _vm.onClickGen
    }
  }, [_vm._v("Generate")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFileUpload),
      expression: "showFileUpload"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    ref: "upload",
    staticClass: "upload-license",
    attrs: {
      "drag": "",
      "action": "uploadRequest",
      "multiple": false,
      "limit": 1,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "on-exceed": _vm.handleUploadExceed,
      "http-request": _vm.uploadRequest
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drag file to here or "), _c('em', [_vm._v("Click to upload file")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Please upload the token file")])])], 1)], 1), _vm._v(" "), _c('el-form', [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenseRecord),
      expression: "showLicenseRecord"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.licenseRecordData,
      "border": "",
      "cell-style": {
        textAlign: 'center'
      },
      "header-cell-style": {
        textAlign: 'center',
        background: '#E5E7E9'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "prop": "outerlicense",
      "label": "Outer License",
      "min-width": "105"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "interlicense",
      "label": "Inter License",
      "min-width": "105"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "er_num",
      "label": "ER Number",
      "formatter": _vm.arrayFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lic_type",
      "label": "License Type",
      "formatter": _vm.licTypeFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "license_content",
      "label": "License Content",
      "formatter": _vm.jsonFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project",
      "label": "Project Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "direct_cus",
      "label": "Direct Customer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_email",
      "label": "Customer Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exp_date",
      "label": "Expiry Date [as UTC(+00:00)]",
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "Operation",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showLicenseRecord),
            expression: "showLicenseRecord"
          }]
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.onClickModify(scope.row)
            }
          }
        }), _vm._v(" "), (_vm.userType === 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.onClickDelete(scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-download"
          },
          on: {
            "click": function($event) {
              return _vm.onClickDownload(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenseRecord),
      expression: "showLicenseRecord"
    }],
    attrs: {
      "type": "success",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.onClickNew()
      }
    }
  }, [_vm._v("Confirm to Generate New")])], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCreateBox),
      expression: "showCreateBox"
    }],
    staticClass: "box-card"
  }, [_c('h2', [_vm._v("Generate License Form")]), _vm._v(" "), _c('el-form', {
    ref: "newLicenseForm",
    attrs: {
      "label-position": "left",
      "model": _vm.newLicenseForm,
      "rules": _vm.genRules,
      "label-width": "150px",
      "disabled": _vm.generating
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Project Name",
      "prop": "project"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.project),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "project", $$v)
      },
      expression: "newLicenseForm.project"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "Direct Customer",
      "prop": "direct_cus"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Please Select",
      "filter-method": _vm.handleCustomerAutoComplete
    },
    on: {
      "change": _vm.handleCustomerInputChange,
      "focus": _vm.getCustomerDataList
    },
    model: {
      value: (_vm.newLicenseForm.direct_cus),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "direct_cus", $$v)
      },
      expression: "newLicenseForm.direct_cus"
    }
  }, _vm._l((_vm.customerData.cus_list), function(item) {
    return _c('el-option', {
      key: item.cus_id,
      attrs: {
        "label": item.name,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "End Customer",
      "prop": "end_cus"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.end_cus),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "end_cus", $$v)
      },
      expression: "newLicenseForm.end_cus"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expiry Date [as UTC(+00:00)]",
      "prop": "exp_date"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Select Date",
      "default-value": new Date(),
      "value-format": "yyyy-MM-ddTHH:mm:ss.000Z",
      "disabled": _vm.datePickerDisable
    },
    on: {
      "change": _vm.OnExpiryDateChange
    },
    model: {
      value: (_vm.tmp_exp_date),
      callback: function($$v) {
        _vm.tmp_exp_date = $$v
      },
      expression: "tmp_exp_date"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.OnCheckBoxChange
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("No Limit")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Customer Email",
      "prop": "user_email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.newLicenseForm.user_email),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "user_email", $$v)
      },
      expression: "newLicenseForm.user_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "ER Number",
      "prop": "er_num"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "multiple": "",
      "placeholder": "Enter ER Number"
    },
    model: {
      value: (_vm.newLicenseForm.er_num),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "er_num", $$v)
      },
      expression: "newLicenseForm.er_num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "NE Point",
      "prop": "ne_point"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "clearable": ""
    },
    model: {
      value: (_vm.newLicenseForm.ne_point),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "ne_point", $$v)
      },
      expression: "newLicenseForm.ne_point"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "Enable White Label",
      "prop": "white_label"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.newLicenseForm.white_label),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "white_label", $$v)
      },
      expression: "newLicenseForm.white_label"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "PI Number",
      "prop": "pi_num"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.pi_num),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "pi_num", $$v)
      },
      expression: "newLicenseForm.pi_num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "Support Duration",
      "prop": "support_dr"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "number",
      "min": "0"
    },
    on: {
      "change": _vm.OnSupportDrChange,
      "blur": _vm.OnSupportDrChange
    },
    model: {
      value: (_vm.newLicenseForm.support_dr),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "support_dr", $$v)
      },
      expression: "newLicenseForm.support_dr"
    }
  }), _vm._v("\n        (years)\n        "), _c('br'), _c('small', {
    staticStyle: {
      "text-align": "left",
      "color": "slateblue"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.newLicenseForm.support_dr_date == null ? "" : _vm.newLicenseForm.support_dr_date.format("DD MMM YYYY")) + "\n      ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sales Name",
      "prop": "sales"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.sales),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "sales", $$v)
      },
      expression: "newLicenseForm.sales"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sales Email",
      "prop": "sales_email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newLicenseForm.sales_email),
      callback: function($$v) {
        _vm.$set(_vm.newLicenseForm, "sales_email", $$v)
      },
      expression: "newLicenseForm.sales_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.generating
    },
    on: {
      "click": _vm.generateLicense
    }
  }, [_vm._v("Generate")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.onClickCancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03bfea8f","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Generate.vue
// module id = Gifs
// module chunks = 1